import { Box, Link } from "@mui/material";
import type { PropsWithChildren } from "react";
import { Link as RouterLink } from "react-router";
import TypographyTooltipEllipsis from "../TypographyTooltipEllipsis";

interface Props {
  to: string | undefined;
  state?: unknown;
  openInNewTab?: boolean;
  // Renders TypographyTooltipEllipsis(text) — ellipsis + tooltip on overflow. Use children instead for rich content.
  text?: string;
}

const GridTextHoverLink = ({ to, state, openInNewTab, text, children }: PropsWithChildren<Props>) => {
  if (!to) {
    return text !== undefined ? (
      <TypographyTooltipEllipsis text={text} />
    ) : (
      <Box sx={{ minWidth: 0, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{children}</Box>
    );
  }

  return (
    <Link
      component={RouterLink}
      to={to}
      state={state}
      target={openInNewTab ? "_blank" : undefined}
      rel={openInNewTab ? "noopener noreferrer" : undefined}
      className="highlighted-action"
      underline="none"
      sx={{
        display: "flex",
        alignItems: "center",
        width: "100%",
        height: "100%",
        minWidth: 0,
        color: "inherit",
        ":hover": { color: "primary.main" },
      }}
    >
      {text !== undefined ? (
        <TypographyTooltipEllipsis text={text} />
      ) : (
        <Box sx={{ flexGrow: 1, minWidth: 0, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
          {children}
        </Box>
      )}
    </Link>
  );
};

export default GridTextHoverLink;
